import script from "./NewChatContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewChatContainer.vue?vue&type=script&setup=true&lang=ts"

import "./NewChatContainer.vue?vue&type=style&index=0&id=19e47d8e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19e47d8e"]])

export default __exports__